import browserStore from '@anm/helpers/browserStore';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect } from 'react';

import getDestinationStorageKey from '../helpers/getDestinationStorageKey';

import { DestinationParams } from './../types';

const useFacebookGroupError = () => {
  const [canShowErrorModal, openErrorModal, closeErrorModal] = useSwitchState();

  const params = browserStore.get(getDestinationStorageKey()) as DestinationParams;
  useEffect(() => {
    if (!params) return;

    const isFacebookAdded = params.network === 'facebook';
    const isError = params.error;

    if (isFacebookAdded && isError) {
      openErrorModal();
    }
  }, [params]);

  return [canShowErrorModal, closeErrorModal] as const;
};

export default useFacebookGroupError;
